/** Normalize ApiResponse / PagedResult / array payloads from the backend. */
export function extractList(response: unknown): any[] {
  if (!response) return [];
  if (Array.isArray(response)) return response;

  const res = response as Record<string, any>;
  if (res['success'] && Array.isArray(res['data'])) return res['data'];

  if (res['success'] && res['data']) {
    const data = res['data'];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.Items)) return data.Items;
  }

  if (Array.isArray(res['items'])) return res['items'];
  if (Array.isArray(res['Items'])) return res['Items'];
  return [];
}
